import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

export const useHandleBackPressed = () => {
  const navigation = useNavigation();
  const onPressBack = useCallback(() => {
    const canGoBack = navigation.canGoBack();

    if (canGoBack) {
      navigation.goBack();
      return;
    }

    window.history.back();
  }, [navigation]);

  return {
    onPressBack,
    showBackButton: window.history.length > 1,
  };
};
